// @flow
import styled, { css } from "styled-components";
import { Link } from "../common/Link";

const PageContainer = styled.div`
  background-color: #ffffff;
`;

const Title = styled.h1`
  padding: 25px 0;
  font-weight: 600;
  font-size: 36px;
  text-align: center;
  color: #343434;

  @media (max-width: 959px) {
    padding: 10px;
    font-size: 24px;
  }
`;

const AboutToggle = styled.div`
  position: relative;
  margin-top: 20px;
  padding: 18px 10px;
  border-radius: 4px;
  background-color: #f6f6f6;
  user-select: none;
  cursor: pointer;

  :after {
    content: "";
    position: absolute;
    top: 50%;
    ${({ theme }) =>
      theme.locale === "ar"
        ? css`
            left: 23px;
          `
        : css`
            right: 23px;
          `};
    transform: rotate(-45deg) translateY(-50%);
    transform-origin: 50%;
    display: block;
    width: 14px;
    height: 14px;
    border-right: 3px solid #b5b5b5;
    border-bottom: 3px solid #b5b5b5;
    transition: all 0.3s ease;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      color: #a5a4a4;
      :before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateY(-50%);
        transform-origin: 0%;
        display: block;
        margin-top: 3px;
        font-size: ${({ theme }) =>
          theme.locale === "ar" ? theme.minFontSize : "12px"};
        line-height: 1;
        font-family: Tahoma, sans-serif;
        text-transform: lowercase;
      }
      :after {
        transform: rotate(45deg) translateY(-50%);
        transform-origin: 100%;
      }
    `};
`;

const AboutTitle = styled.h2`
  font-size: 36px;
  font-weight: bold;
  color: #a7a7a7;
  text-align: center;
  user-select: none;
  cursor: pointer;

  @media (max-width: 959px) {
    font-size: 24px;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  margin-bottom: 24px;
  padding: 0 10px;

  @media (max-width: 959px) {
    padding: 0 15px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 20px;
  background-color: #f6f6f6;
  border-radius: 4px;

  @media (max-width: 959px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 0;
    background-color: transparent;
  }
`;

const AccountInfo = styled.div`
  min-width: 200px;

  @media (max-width: 959px) {
    direction: ${({ theme }) => theme.direction};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 2px;
    padding: 8px 14px;
    background-color: #f6f6f6;
    border-radius: 4px;
  }
`;

const Counts = styled.ul`
  direction: ${({ theme }) => theme.direction};
  padding-left: 50px;
  border-left: 3px solid #a7a7a7;
  list-style: disc;

  @media (max-width: 959px) {
    width: 100%;
    padding: 8px 14px 8px 30px;
    background-color: #f6f6f6;
    border-radius: 4px;
    border-left: none;
  }

  @media (max-width: 479px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Status = styled.div`
  direction: ${({ theme }) => theme.direction};
  font-weight: 700;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
`;

const UserEmail = styled.div`
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 700;
  color: #343434;

  @media (max-width: 959px) {
    margin-right: ${({ theme }) => (theme.direction === "rtl" ? "0" : "7px")};
    margin-left: ${({ theme }) => (theme.direction === "rtl" ? "7px" : "0")};
    margin-bottom: 0;
  }

  > a {
    font-size: 16px;
    font-weight: 700;
    color: #343434;
    text-decoration: none;

    @media (max-width: 959px) {
      font-size: ${({ theme }) =>
        theme.locale === "ar" ? theme.minFontSize : "14px"};
    }

    @media (max-width: 479px) {
      font-size: ${({ theme }) =>
        theme.locale === "ar" ? theme.minFontSize : "12px"};
      font-weight: 400;
    }

    :hover {
      text-decoration: underline;
    }
  }
`;

const UserId = styled.div`
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  color: #95989a;

  @media (max-width: 959px) {
    > svg:first-of-type {
      display: none;
    }
  }

  > a {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "12px"};
    color: #95989a;
    text-decoration: none;

    :hover {
      text-decoration: underline;
    }
  }
`;

const Count = styled.li`
  margin-bottom: 12px;
  line-height: 1.2;

  :last-child {
    margin-bottom: 0;
  }

  @media (max-width: 479px) {
    width: 100%;
    margin-top: 9px;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
`;

const Numbers = styled.div`
  display: inline;
  font-size: 18px;
  font-weight: 700;
  color: ${props => props.theme.indexMajor};

  @media (max-width: 959px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
  }
`;

export const InvitedTournamentName = styled.div`
  display: inline;
  font-weight: 700;
  color: ${props => props.theme.indexMajor};
`;

const Text = styled.div`
  direction: ${({ theme }) => theme.direction};
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: #a7a7a7;

  @media (max-width: 959px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "12px"};
  }

  @media (max-width: 479px) {
    max-width: 100%;
  }
`;

const Tabs = styled.div`
  direction: ${({ theme }) => theme.direction};
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 52px;
  margin-top: 37px;
  border-bottom: 4px solid #f6f6f6;

  @media (max-width: 959px) {
    margin-top: 25px;
  }
`;

const Tab = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 25%;
  flex-basis: 25%;
  text-align: center;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  font-weight: 700;
  color: #343434;
  cursor: pointer;
  user-select: none;
  border-radius: 4px 4px 0 0;

  @media (max-width: 959px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "12px"};
  }

  @media (max-width: 479px) {
    font-size: 12px;
  }

  :hover {
    background-color: #f6f6f6;
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.indexMajor};
      background-color: #f6f6f6;
    `};
`;

const Tournaments = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding-top: 24px;

  @media (max-width: 969px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
`;

const Bottom = styled.div`
  direction: ${({ theme }) => theme.direction};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 959px) {
    justify-content: center;
  }

  ${({ activeTab }) =>
    activeTab === "activeFreeTournaments" &&
    css`
      justify-content: flex-end !important;
    `};
`;

const PaginationSelect = styled.div`
  direction: ${props => props.theme.direction};
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > div:last-of-type {
    min-width: 79px;
  }

  @media (max-width: 959px) {
    display: none;
  }
`;

const SelectText = styled.div`
  margin-right: 25px;
  ${({ theme }) =>
    theme.locale === "ar"
      ? css`
          margin-left: 25px;
        `
      : css`
          margin-right: 25px;
        `};
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: #717171;
`;

const HelpContainer = styled.div`
  direction: ${props => props.theme.direction};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 959px) {
    display: none;
  }
`;

const HelpLink = styled(Link)`
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: ${props => props.theme.indexMajor};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
  color: #a7a7a7;
  user-select: none;

  :hover {
    color: #717171;
  }

  ${props =>
    props.right &&
    css`
      transform: rotate(180deg);
    `};

  ${props =>
    props.disabled &&
    css`
      cursor: default;
      color: #a7a7a7;
      opacity: 0.5;

      :hover {
        color: #a7a7a7;
      }
    `};
`;

const PaginationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: #a7a7a7;
  border: 3px solid transparent;
  cursor: pointer;
  user-select: none;

  :hover {
    font-weight: 700;
    color: ${props => props.theme.indexMajor};
  }

  ${props =>
    props.active &&
    css`
      font-weight: 700;
      color: #717171;
      border-color: #efefef;
      cursor: default;
    `};

  ${props =>
    props.disabled &&
    css`
      color: #a7a7a7 !important;
      font-weight: 400 !important;
      cursor: default;
    `};
`;

const SpinnerContainer = styled.div`
  height: ${props => props.spinnerHeight}px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-bottom: 20px;

  @media (max-width: 959px) {
    height: auto !important;
  }
`;

const Bar = styled.div`
  position: relative;
  flex: 1;
  width: 6px;
  margin-right: 3px;
  background-color: ${({ theme }) => theme.accent};
  z-index: 1;
`;

export {
  Title,
  AboutToggle,
  AboutTitle,
  Container,
  UserInfo,
  AccountInfo,
  Status,
  UserEmail,
  UserId,
  Counts,
  Count,
  Numbers,
  Text,
  Tabs,
  Tab,
  Tournaments,
  Bottom,
  PaginationSelect,
  SelectText,
  HelpContainer,
  HelpLink,
  Pagination,
  Arrow,
  PaginationItem,
  SpinnerContainer,
  Bar,
  PageContainer
};



// WEBPACK FOOTER //
// ./src/components/Tournaments/styles.js